export const API_BASE_URL = 'https://sfaapiv2.laugfs.lk/api';